"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _components = _interopRequireDefault(require("../../../styles/components"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _TimeLabel = _interopRequireDefault(require("../../Labels/TimeLabel"));

var _Slider = _interopRequireDefault(require("../../../common/Slider"));

var _ToolTip = _interopRequireDefault(require("../../../common/ToolTip"));

var _Button = _interopRequireDefault(require("../../../common/Button"));

var _reactDraggable = _interopRequireDefault(require("react-draggable"));

var _circle = _interopRequireDefault(require("../../../assets/icons/circle.gif"));

var _close = _interopRequireDefault(require("../../../assets/icons/close.svg"));

var _maximize = _interopRequireDefault(require("../../../assets/icons/maximize.svg"));

var _playNextPreviousMedia = _interopRequireDefault(require("../utils/playNextPreviousMedia"));

var _VoicebaseReactPlayerContext = _interopRequireDefault(require("../../../VoicebaseReactPlayerContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.media, {
    queries: state.query
  });
};

var Index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Index, _React$PureComponent);

  function Index(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "skipBackward", function () {
      var _this$props = _this.props,
          onSeek = _this$props.onSeek,
          duration = _this$props.duration,
          currentTime = _this$props.currentTime;
      var skipTime = currentTime - 15000; // currentTime - (duration / 20);

      onSeek({
        s: skipTime < 0 ? 0 : skipTime
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getHitMarks", (0, _memoizeOne["default"])(function (queries) {
      var _ref;

      return queries && (_ref = []).concat.apply(_ref, queries.map(function (query) {
        return query.hits;
      })).reduce(function (acc, hit) {
        var _extends2;

        return _extends({}, acc, (_extends2 = {}, _extends2[_.get(hit, "s", [])] = /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressMark, null), _extends2));
      }, {});
    }));

    _defineProperty(_assertThisInitialized(_this), "seek", function (value) {
      var _this$props2 = _this.props,
          onSeek = _this$props2.onSeek,
          duration = _this$props2.duration;
      onSeek({
        s: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var onPlay = _this.props.onPlay;

      _this.setState({
        onHoverPlay: true
      });

      onPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function () {
      var onPause = _this.props.onPause;
      onPause();
    });

    _defineProperty(_assertThisInitialized(_this), "skipToEnd", function () {
      var _this$props3 = _this.props,
          onSeek = _this$props3.onSeek,
          duration = _this$props3.duration;
      onSeek({
        s: duration
      });
    });

    _this.state = {
      nextColor: "#677791",
      onHoverPlay: true
    };
    return _this;
  }

  var _proto = Index.prototype;

  _proto.renderTooltip = function renderTooltip(value) {
    return /*#__PURE__*/_react["default"].createElement(_TimeLabel["default"], {
      ms: value
    });
  };

  _proto.render = function render() {
    var _agentDetail$extended,
        _agentDetail$extended2,
        _agentDetail$extended3,
        _agentDetail$extended4,
        _agentDetail$callDeta,
        _agentDetail$callDeta2,
        _this2 = this;

    var _this$props4 = this.props,
        readyState = _this$props4.readyState,
        transcript = _this$props4.transcript,
        _this$props4$duration = _this$props4.duration,
        duration = _this$props4$duration === void 0 ? 0 : _this$props4$duration,
        queries = _this$props4.queries,
        _this$props4$currentT = _this$props4.currentTime,
        currentTime = _this$props4$currentT === void 0 ? 0 : _this$props4$currentT,
        paused = _this$props4.paused,
        isMiniPlayerVisible = _this$props4.isMiniPlayerVisible,
        setClickMinMaxPlayerVisible = _this$props4.setClickMinMaxPlayerVisible,
        metaData = _this$props4.metaData,
        hidePlayer = _this$props4.hidePlayer,
        mediaId = _this$props4.mediaId;
    var loading = readyState < 2;
    var agentDetail = metaData === null || metaData === void 0 ? void 0 : metaData.detail;
    var agentExtendedName = "" + ((agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended = agentDetail.extended) === null || _agentDetail$extended === void 0 ? void 0 : _agentDetail$extended.agent_first_name) ? (agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended2 = agentDetail.extended) === null || _agentDetail$extended2 === void 0 ? void 0 : _agentDetail$extended2.agent_first_name) + " " : "") + ((agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended3 = agentDetail.extended) === null || _agentDetail$extended3 === void 0 ? void 0 : _agentDetail$extended3.agent_last_name) ? agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$extended4 = agentDetail.extended) === null || _agentDetail$extended4 === void 0 ? void 0 : _agentDetail$extended4.agent_last_name : "");
    var agentName = agentDetail === null || agentDetail === void 0 ? void 0 : (_agentDetail$callDeta = agentDetail.callDetails) === null || _agentDetail$callDeta === void 0 ? void 0 : (_agentDetail$callDeta2 = _agentDetail$callDeta.agent) === null || _agentDetail$callDeta2 === void 0 ? void 0 : _agentDetail$callDeta2.fullName;
    var parsedDate = (agentDetail === null || agentDetail === void 0 ? void 0 : agentDetail.parsedDate) || (agentDetail === null || agentDetail === void 0 ? void 0 : agentDetail.startTime);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMiniPlayerVisible && /*#__PURE__*/_react["default"].createElement(_components["default"].MiniPlayerContainer, null, /*#__PURE__*/_react["default"].createElement(_components["default"].MiniPlayerBody, null, /*#__PURE__*/_react["default"].createElement(_reactDraggable["default"], {
      handle: "div"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mini-player-draggable"
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].MiniPlayerControlBar, null, /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControls, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControlTitle, null, agentName || agentExtendedName || "No agent details")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControlSubTitle, null, parsedDate ? "on " + parsedDate : ""))), /*#__PURE__*/_react["default"].createElement(_components["default"].PrimaryControls, {
      className: "minimize-icon"
    }, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Maximize",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Maximize"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: "maximize-icon",
      src: _maximize["default"],
      alt: "mini player maximize icon",
      onClick: function onClick() {
        return setClickMinMaxPlayerVisible();
      }
    })), /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Close Player",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Close Player"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: "mini-player-close-icon",
      src: _close["default"],
      alt: "mini player close icon",
      onClick: hidePlayer
    })))), /*#__PURE__*/_react["default"].createElement(_components["default"].MiniPlayerControlBar, {
      style: {
        marginTop: "10px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, {
      style: {
        marginLeft: "0px",
        marginRight: "10px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Rewind",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Rewind"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: this.skipBackward
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.98975 6.48218H1.98975V3.48218",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.11107 12.1391C4.88025 12.9083 5.86026 13.4321 6.92716 13.6443C7.99405 13.8565 9.09992 13.7476 10.1049 13.3313C11.1099 12.9151 11.9689 12.2101 12.5732 11.3056C13.1776 10.4012 13.5002 9.3378 13.5002 8.25C13.5002 7.16221 13.1776 6.09884 12.5732 5.19437C11.9689 4.2899 11.1099 3.58495 10.1049 3.16867C9.09992 2.75238 7.99405 2.64346 6.92716 2.85568C5.86026 3.0679 4.88025 3.59173 4.11107 4.36092L1.98975 6.48224",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIcon, {
      style: {
        marginTop: "-10px"
      }
    }, paused ? /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Play",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Play"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "primary",
      onClick: this.play,
      loading: loading,
      disabled: loading,
      shape: "circle",
      size: "lg",
      icon: "caret-right"
    })) : /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginRight: "10px",
        cursor: "pointer"
      }
    }, this.state.onHoverPlay ? /*#__PURE__*/_react["default"].createElement("img", {
      src: _circle["default"],
      alt: "loading...",
      className: "player-content",
      onClick: this.pause,
      loading: loading,
      disabled: loading,
      onMouseOver: function onMouseOver() {
        return _this2.setState({
          onHoverPlay: false
        });
      }
    }) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "mini-player-button"
    }, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Pause",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Pause"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      icon: "pause",
      type: "primary",
      size: "lg",
      shape: "circle",
      onClick: this.pause,
      loading: loading,
      disabled: loading,
      onMouseLeave: function onMouseLeave() {
        return _this2.setState({
          onHoverPlay: true
        });
      }
    }))))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressSlider, {
      style: {
        display: "inline-flex",
        width: "100%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
      horizontal: true,
      min: 0,
      max: duration,
      value: currentTime,
      tipFormatter: this.renderTooltip,
      onChange: this.seek // TODO: use a method call
      ,
      style: {
        margin: 5,
        flex: 1
      },
      dotStyle: {
        display: "none"
      }
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Next",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Next"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onMouseOver: function onMouseOver() {
        return _this2.setState({
          nextColor: "#262D38"
        });
      },
      onMouseLeave: function onMouseLeave() {
        return _this2.setState({
          nextColor: "#677791"
        });
      },
      onClick: function onClick() {
        return (0, _playNextPreviousMedia["default"])(_extends({}, _this2.context, {
          mediaId: mediaId,
          nextOrPrevious: "next"
        }));
      }
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M1.5 8.64697H11.5",
      stroke: this.state.nextColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.99951 13.147L11.4995 8.64697L6.99951 4.14697",
      stroke: this.state.nextColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.5 13.647V3.64697",
      stroke: this.state.nextColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressTime, {
      style: {
        marginLeft: "10px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_TimeLabel["default"], {
      ms: currentTime
    }), " /", " ", /*#__PURE__*/_react["default"].createElement(_TimeLabel["default"], {
      ms: duration
    }))))))));
  };

  return Index;
}(_react["default"].PureComponent);

_defineProperty(Index, "contextType", _VoicebaseReactPlayerContext["default"]);

var _default = (0, _connectToMedia["default"])(mapStateToProps)(Index);

exports["default"] = _default;